// @ts-nocheck
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import {
    DispatchUpdateConfigurationSelection,
    LoadRealTimeInventory,
    LoadRealTimePricing,
    SetConfigurationCompleted,
    SetProductInfo,
} from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/UpdateConfigurationSelection";
import { FilterConfiguration } from "@store/Extensions/Store/Pages/ProductDetails/Handlers/UpdateConfigurationSelection";
import cloneDeep from "lodash/cloneDeep";

interface Parameter {
    configSectionId?: string;
    sectionOptionId?: string;
    productId: string;
}

interface Props {
    configurationSelection: SafeDictionary<string>;
    configurationCompleted: boolean;
    productInfo?: ProductInfo;
}

type HandlerType = Handler<Parameter, Props>;

export const ClearCurrentValues: HandlerType = props => {
    const productDetail = props.getState().pages.productDetails;
    const configurationSelection = cloneDeep(productDetail.configurationSelection);
    for (const key in configurationSelection) {
        configurationSelection[key] = "";
    }

    props.configurationSelection = configurationSelection;
};

export const chain = [
    ClearCurrentValues,
    FilterConfiguration,
    SetConfigurationCompleted,
    SetProductInfo,
    LoadRealTimePricing,
    LoadRealTimeInventory,
    DispatchUpdateConfigurationSelection,
];

const clearConfigurationSelection = createHandlerChainRunner(chain, "ClearConfigurationSelection");
export default clearConfigurationSelection;
